import { widget } from "@foretagsplatsen/widgetjs";

/**
 * `periodReportAttachmentsWidget` is a widget used to display a list of report attachments
 * by displaying big icons based on the file type.
 *
 * @param {*} spec - Parameter object
 * @param {periodReport} spec.report - Report that contains the attachments
 * @param {*} my - protected fields holder
 * @return {{}}
 */
function periodReportAttachmentsWidget(spec, my) {
	spec ||= {};
	my ||= {};

	my.report = spec.report;

	const that = widget(spec, my);

	that.setReport = function (report) {
		my.report = report;
		that.update();
	};

	that.renderContentOn = function (html) {
		html.div(
			{ klass: "report-attachments" },
			my.getAttachments().map((attachment) =>
				html.span(
					{ klass: "attachment" },
					html.a(
						{
							klass: "attachment-link",
							target: "_blank",
							href: attachment.getContentPath(),
						},
						html.div({
							klass: [
								"icon",
								"big_icon",
								`di-${attachment.getFileExtension()}`,
							],
						}),
						html.div(
							{
								klass: "name",
							},
							attachment.getFilename(),
						),
					),
				),
			),
		);
	};

	my.getAttachments = function () {
		return my.report ? my.report.getAttachments() : [];
	};

	return that;
}

export default periodReportAttachmentsWidget;
